import React from 'react';
interface ChartSkeletonProps {
  variant?: 'bar' | 'pie' | 'line';
  className?: string;
}
export function ChartSkeleton({
  variant = 'bar',
  className = ''
}: ChartSkeletonProps) {
  return <div className={`bg-gray-800 rounded-lg overflow-hidden ${className}`} data-id="element-261">
      <div className="p-4 border-b border-gray-700" data-id="element-262">
        <div className="h-5 bg-gray-700 rounded w-1/3 animate-pulse" data-id="element-263"></div>
      </div>
      <div className="p-6" data-id="element-264">
        <div className="flex items-center justify-center h-64" data-id="element-265">
          {variant === 'pie' ? <div className="relative" data-id="element-266">
              <div className="h-40 w-40 rounded-full bg-gray-700 animate-pulse" data-id="element-267"></div>
              <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 h-20 w-20 rounded-full bg-gray-800" data-id="element-268"></div>
            </div> : variant === 'bar' ? <div className="w-full h-full flex items-end space-x-2" data-id="element-269">
              {[35, 60, 45, 80, 55, 70, 40].map((height, index) => <div key={index} className="bg-gray-700 rounded-t animate-pulse" style={{
            height: `${height}%`,
            width: `${100 / 7 - 2}%`,
            animationDelay: `${index * 100}ms`
          }} data-id="element-270"></div>)}
            </div> : <div className="w-full h-full flex items-center" data-id="element-271">
              <svg className="w-full h-3/4" viewBox="0 0 400 100" data-id="element-272">
                <path d="M0,50 Q50,20 100,50 T200,50 T300,50 T400,50" fill="none" stroke="#4B5563" strokeWidth="4" className="animate-pulse" data-id="element-273" />
              </svg>
            </div>}
        </div>
        <div className="mt-4 flex justify-center space-x-4" data-id="element-274">
          {[1, 2, 3, 4].map((_, index) => <div key={index} className="h-3 bg-gray-700 rounded w-16 animate-pulse" data-id="element-275"></div>)}
        </div>
      </div>
    </div>;
}